const initalState = {
  id: '',
  nama: '',
  email: '',
  checksum: '',
};

/**
 * @function userProfileReducers
 * @summary userProfileReducers reducers that change the global state based on actions.
 * @param {object} state - Initial global state.
 * @param {func} action - Action object.
 * @return {object} Updated global state.
 */
const userProfileReducers = (state = initalState, action) => {
  switch (action.type) {
    case 'USER_PROFILE':
      return {
        id: action.payload.id,
        nama: action.payload.nama,
        email: action.payload.email,
        checksum: action.payload.checksum,
      };
    default:
      return state;
  }
};

export default userProfileReducers;
